import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-13768 — an agreement term a client signed (the Customer Agreement's Initial Term
 * Length), stored when staff process the signed submission.
 *
 * `termMonths` 0 is month to month: no end date. `earlyRemovalUntil` is the end of the
 * early-removal window the terms name (a tenant setting, months from the start), shown
 * wherever staff schedule the pick-up of the client's merchandisers. Information only:
 * nothing is charged automatically.
 */
@Index('idx_client_agreement_client', ['fkClientId'], {})
@Entity('client_agreement')
export class ClientAgreementEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'fk_form_submission__id', nullable: true, unsigned: true })
	public fkFormSubmissionId!: number | null;

	@Column('int', { name: 'fk_sent_form__id', nullable: true, unsigned: true })
	public fkSentFormId!: number | null;

	// The form's name when it was signed ("Packaged Ice Delivery & Merchandiser Rental
	// Agreement").
	@Column('varchar', { name: 'agreementName', length: 255 })
	public agreementName!: string;

	@Column('date', { name: 'startDate' })
	public startDate!: string;

	@Column('int', { name: 'termMonths', unsigned: true, default: () => "'0'" })
	public termMonths!: number;

	@Column('varchar', { name: 'termLabel', length: 60 })
	public termLabel!: string;

	@Column('date', { name: 'endDate', nullable: true })
	public endDate!: string | null;

	@Column('date', { name: 'earlyRemovalUntil', nullable: true })
	public earlyRemovalUntil!: string | null;

	// Tenant user id of the staff member who processed it.
	@Column('int', { name: 'fk_user__id', nullable: true, unsigned: true })
	public fkUserId!: number | null;
}
